import { findIndex } from "@dhx/ts-common/core";
import { Id } from "@dhx/ts-common/types";
import { ICol, IRow, ISpan } from "./../types";

export function getWidth(columns: ICol[], colspan: number, index: number) {
	const cols = columns.filter(({ hidden }) => !hidden);
	if (!colspan) {
		return cols[index].$width;
	}
	return cols.reduce((width, { $width }, i) => {
		width += i >= index && i < index + colspan ? $width : 0;
		return width;
	}, 0);
}

export function getHeight(dataRows: IRow[], rowspan: number, index: number) {
	const rows = dataRows.filter(({ hidden }) => !hidden);
	if (!rowspan) {
		return rows[index].$height;
	}
	return rows.reduce((height, { $height }, i) => {
		height += i >= index && i < index + rowspan ? $height : 0;
		return height;
	}, 0);
}

export function getSpan(rowId: Id, colId: Id, conf: any): ISpan {
	if (conf.spans) {
		const rowIndex = conf.data.findIndex(item => item.id.toString() === rowId.toString());
		const colIndex = conf.columns.findIndex(col => col.id.toString() === colId);

		const index = findIndex(conf.spans, span => {
			const startRowInd = conf.data.findIndex(item => item.id.toString() === span.row.toString());
			const startColInd = conf.columns.findIndex(col => col.id.toString() === span.column.toString());
			const rows = {
				start: startRowInd,
				end: span.rowspan ? startRowInd + span.rowspan : startRowInd + 1,
			};
			const cols = {
				start: startColInd,
				end: span.colspan ? startColInd + span.colspan : startColInd + 1,
			};
			return (
				rowIndex >= rows.start && rowIndex < rows.end && colIndex >= cols.start && colIndex < cols.end
			);
		});
		return conf.spans[index];
	}
}
